import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, Request, Headers, ResponseContentType, ResponseOptions } from '@angular/http';
import { Observable } from 'rxjs';
import { HttpClient, HttpRequest, HttpEvent, HttpResponse } from '@angular/common/http';
import 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';
import 'rxjs/add/Observable/throw';
import 'rxjs/add/operator/toPromise';
import { global } from '../../models/global';
import { ApprovedQuantity } from '../../Models/MCPlanningMaterial/mcplanningmaterial';
import { MaterialDispatchDetails, UserDetails } from '../../Models/Material-Dispatch/MaterialDispatch';
import { HttpInterceptor,  HttpHandler, HttpErrorResponse } from '@angular/common/http';
import { MultiSelectCancellation } from 'src/app/Models/Dashboard/DashboardFilters';



@Injectable({
    providedIn: 'root'
})
export class MCPlanningMaterialService  {
    private apiUploadUrl: string;
    ROOT_URL: string = "";
    constructor(private http: Http) {
        let g: global = new global();
        this.ROOT_URL = g.getApiUrl();
        this.apiUploadUrl = this.ROOT_URL + '/api/AnnualRequirement/UploadFile';
    }

    downloadAnnualRequirementExcel(brand: any, month: any, crop: any, jobtype: any, state: any, year:any): Observable<any> {
        let userID = localStorage.getItem('mcmt_userId');
        let roleId = localStorage.getItem('mcmt_roleID');
        let Brand = brand;
        let Crop = crop;
        let JobType = jobtype;
        let Month = month;
        let State = state;
        let Year = year;
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions: RequestOptions = new RequestOptions({

            method: 'GET',
            url: this.ROOT_URL + "/api/AnnualRequirement/DownloadAnnualRequirementExcel?UserID=" + userID + "&RoleId=" + roleId
                + "&Brand=" + Brand + "&Crop=" + Crop + "&JobType=" + JobType + "&Month=" + Month + "&State=" + State+ "&Year=" + Year,
            headers: headers,
            responseType: ResponseContentType.Blob
        })

        return this.http.request(new Request(requestoptions))
            .map((res: Response) => {
                var blob = new Blob([res.blob()], { type: 'xlsx' })
                return blob;
            });

    }
    getdataonbrandselection(brand: any, crop: any, jobtype: any): Observable<any> {
        let _body = {
            "UserID": localStorage.getItem('mcmt_userId'),
            "Brand": brand,
            "Crop": crop,
            "JobType": jobtype
        }

        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'POST',
            url: this.ROOT_URL + "/api/AnnualRequirement/Getdataonbrandselection",
            headers: headers,
            body: _body
        })

        return this.http.request(new Request(requestoptions))
            .map((res: Response) => {
                return res.json();
            });

    }
    downloadFile(fileName: string, url: string) {
        url = this.ROOT_URL + url;
        return this.http.get(url, {
            responseType: ResponseContentType.Blob//, search: // query string if have
        }).map(res => {
            return {

                filename: fileName,
                data: res.blob()

            };
        }).subscribe(res => {
            window.location.href = this.ROOT_URL + '/Templates/' + res.filename;
        }, error => {
            console.log('download error:', JSON.stringify(error));
        }, () => {
            console.log('Completed file download.')
        });
    }

    public uploadFile(file: Blob): Observable<any> {
        const formData = new FormData();
        formData.append('file', file);
        let userID = localStorage.getItem('mcmt_userId');
        let roleId = localStorage.getItem('mcmt_roleID');
        let headers = new Headers({ 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions: RequestOptions = new RequestOptions({

            method: 'POST',
            url: this.ROOT_URL + "/api/AnnualRequirement/UploadFile?UserID=" + userID + "&RoleId=" + roleId + "&formFile" + formData,
            headers: headers,
            body: formData
        })

        return this.http.request(new Request(requestoptions))
            .map((res: Response) => {
                return res.json();
            });
    }

    finalRequirementFilters(year:any): Observable<any> {
        let userID = localStorage.getItem('mcmt_userId');
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'GET',
            url: this.ROOT_URL + "/api/FinalRequirement/FinalRequirementFilters?userID=" + userID+"&year="+year,
            headers: headers
        })

        return this.http.request(new Request(requestoptions))
            .map((res: Response) => {
                return res.json();
            });

    }
    getAnnualRequirementDetail(type: any, brand: any, crop: any, month: any,year:any): Observable<any> {
        let _body = {
            "UserID": localStorage.getItem('mcmt_userId'),
            "JobType": type,
            "Brand": brand,
            "Crop": crop,
            "Month": month,
            "Year": year
        }
        let headers = new Headers({ 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'POST',
            url: this.ROOT_URL + "/api/AnnualRequirement/GetAnnualRequirementDetail",
            headers: headers,
            body: _body
        })

        return this.http.request(new Request(requestoptions))
            .map((res: Response) => {
                return res.json();
            });

    }

    getAnnualRequirementFilters(): Observable<any> {
        let userID = localStorage.getItem('mcmt_userId');
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'GET',
            url: this.ROOT_URL + "/api/AnnualRequirement/GetAnnualRequirementFilters?userID=" + userID,
            headers: headers
        })

        return this.http.request(new Request(requestoptions))
            .map((res: Response) => {
                return res.json();
            });

    }

    finalRequirementDetails(pageNo :number,jobNumber: string, name: string, type: string, brand: string, crop: string, requirementType: string, language: string, status: any, bm: string, ma: string, month: string, state: string,year:string): Observable<any> {
        let _body = {
            "UserID": localStorage.getItem('mcmt_userId'),
            "JobNumber": jobNumber,
            "RMHName": name,
            "JobType": type,
            "Brand": brand,
            "Crop": crop,
            "RequirementType": requirementType,
            "Language": language,
            "OrderStatus": status,
            "BM": bm,
            "MA": ma,
            "Month": month,
            "State": state,
            "Year": year,
            "pageNo":pageNo
        }

        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'POST',
            url: this.ROOT_URL + "/api/FinalRequirement/FinalRequirementDetails",
            headers: headers,
            body: _body
        })

        return this.http.request(new Request(requestoptions))
            .map((res: Response) => {
                return res.json();
            });

    }

    uploadDocument(documents: File): Observable<any> {
        const formData = new FormData();
        formData.append("file", documents);
        formData.append("UserId", localStorage.getItem('mcmt_userId'));
        formData.append("RoleId", localStorage.getItem('mcmt_roleID'));

        let headers = new Headers({ 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions: RequestOptions = new RequestOptions({
            headers: headers
        })
        return this.http.post(this.ROOT_URL + "/api/AnnualRequirement/UploadDocument", formData, requestoptions)
            .map((res: Response) => {
                return res.json();
            });
    }
    uploadMaterialDispatchDocument(documents: File): Observable<any> {
        const formData = new FormData();
        formData.append("file", documents);
        formData.append("UserId", localStorage.getItem('mcmt_userId'));

        let headers = new Headers({ 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions: RequestOptions = new RequestOptions({
            headers: headers
        })
        return this.http.post(this.ROOT_URL + "/api/MaterialDispatch/UploadMaterialDispatchDocument", formData, requestoptions)
            .map((res: Response) => {
                return res.json();
            });
    }
    downloadFinalRequirementExcel(jobNumber: string, name: string, type: string, brand: string, crop: string, requirementType: string, language: string, status: any, bm: string, ma: string, month: string, state: string,roleId:any,year:string): Observable<any> {
        let _body = {
            "UserID": localStorage.getItem('mcmt_userId'),
            "JobNumber": jobNumber,
            "RMHName": name,
            "JobType": type,
            "Brand": brand,
            "Crop": crop,
            "RequirementType": requirementType,
            "Language": language,
            "OrderStatus": status,
            "BM": bm,
            "MA": ma,
            "Month": month,
            "State": state,
            "Year": year
        }

        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'POST',
            url:roleId=='47'?this.ROOT_URL + "/api/FinalRequirement/DownloadFinalRequirementExcel":this.ROOT_URL + "/api/FinalRequirement/DownloadBrandManagerRequirementExcel",
            headers: headers,
            body: _body,
            responseType: ResponseContentType.Blob
        })
        return this.http.request(new Request(requestoptions))
            .map((res: Response) => {
                var blob = new Blob([res.blob()], { type: 'xlsx' })
                return blob;
            });

    }

    approveReviewFinalRequirement(approvedQuantity: ApprovedQuantity[]): Observable<any> {
        let _body = {
            "UserID": localStorage.getItem('mcmt_userId'),
            "ApprovedDetail": approvedQuantity
        }

        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'POST',
            url: this.ROOT_URL + "/api/FinalRequirement/ApproveReviewFinalRequirement",
            headers: headers,
            body: _body
        })

        return this.http.request(new Request(requestoptions))
            .map((res: Response) => {
                return res.json();
            });

    }
    getdataonfilterselection(jobNumber: any, rmh: any): Observable<any> {
        let _body = {
            "UserID": localStorage.getItem('mcmt_userId'),
            "JobNumber": jobNumber,
            "RMHName": rmh
        }

        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'POST',
            url: this.ROOT_URL + "/api/Dashboard/GetRMHJobnumber",
            headers: headers,
            body: _body
        })

        return this.http.request(new Request(requestoptions))
            .map((res: Response) => {
                return res.json();
            });

    }
    uploadApprovedQuantity(documents: File): Observable<any> {
        const formData = new FormData();
        formData.append("file", documents);
        formData.append("UserId", localStorage.getItem('mcmt_userId'));

        let headers = new Headers({ 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions: RequestOptions = new RequestOptions({
            headers: headers
        })
        return this.http.post(this.ROOT_URL + "/api/FinalRequirement/ApproveReviewFinalRequirementExcel", formData, requestoptions)
            .map((res: Response) => {
                return res.json();
            });
    }


    downloadAdditionalRequirementExcel(brand: any, month: any, crop: any, jobtype: any, state: any,year:any): Observable<any> {
        let userID = localStorage.getItem('mcmt_userId');
        let roleId = localStorage.getItem('mcmt_roleID');
        let Brand = brand;
        let Crop = crop;
        let JobType = jobtype;
        let Month = month;
        let State = state;
        let Year = year
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions: RequestOptions = new RequestOptions({

            method: 'GET',
            url: this.ROOT_URL + "/api/AdditionalRequirement/DownloadAdditionalRequirementExcel?UserID=" + userID + "&RoleId=" + roleId
                + "&Brand=" + Brand + "&Crop=" + Crop + "&JobType=" + JobType + "&Month=" + Month + "&State=" + State+ "&Year=" + Year,
            //url: this.ROOT_URL + "/api/AnnualRequirement/DownloadAnnualRequirementExcel?UserID="+ userID +"&RoleId="+roleId,
            headers: headers,
            responseType: ResponseContentType.Blob
        })

        return this.http.request(new Request(requestoptions))
            .map((res: Response) => {
                var blob = new Blob([res.blob()], { type: 'xlsx' })
                return blob;
            });

    }
    GetAdditionalRequirementDetail(type: string, brand: string, crop: string, month: string,year:string,state:string): Observable<any> {
        let _body = {
            "UserID": localStorage.getItem('mcmt_userId'),
            "JobType": type,
            "Brand": brand,
            "Crop": crop,
            "Month": month,
            "Year": year,
            "State": state
        }
        let headers = new Headers({ 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'POST',
            url: this.ROOT_URL + "/api/AdditionalRequirement/GetAdditionalRequirementDetail",
            headers: headers,
            body: _body
        })

        return this.http.request(new Request(requestoptions))
            .map((res: Response) => {
                return res.json();
            });

    }
    uploadAdditionalRequirement(documents: File): Observable<any> {
        const formData = new FormData();
        formData.append("file", documents);
        formData.append("UserId", localStorage.getItem('mcmt_userId'));
        formData.append("RoleId", localStorage.getItem('mcmt_roleID'));

        let headers = new Headers({ 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions: RequestOptions = new RequestOptions({
            headers: headers
        })
        return this.http.post(this.ROOT_URL + "/api/AdditionalRequirement/UploadAdditionalRequirement", formData, requestoptions)
            .map((res: Response) => {
                return res.json();
            });
    }

    getAdditionalRequirementFilters(): Observable<any> {
        let userID = localStorage.getItem('mcmt_userId');
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'GET',
            url: this.ROOT_URL + "/api/AdditionalRequirement/GetAdditionalRequirementFilters?userID=" + userID,
            headers: headers
        })

        return this.http.request(new Request(requestoptions))
            .map((res: Response) => {
                return res.json();
            });

    }

    //#region  Material Allocation
    getMaterialAllocationFilter(): Observable<any> {
        let userID = localStorage.getItem('mcmt_userId');
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'GET',
            url: this.ROOT_URL + "/api/MaterialAllocation/MaterialAllocationFilter?userID=" + userID,
            headers: headers
        })

        return this.http.request(new Request(requestoptions))
            .map((res: Response) => {
                return res.json();
            });

    }
    materialAllocationDetails(rmhName: string, jobtype: string, brand: string, crop: string, language: string, month: string, jobNumber: string, state: string, status: string,year:string): Observable<any> {
        let _body = {
            "UserID": localStorage.getItem('mcmt_userId'),
            "RMHName": rmhName,
            "JobType": jobtype,
            "Brand": brand,
            "Crop": crop,
            "Language": language,
            "OrderStatus": status,
            "Month": month,
            "JobNumber": jobNumber,
            "State": state,
            "Status": status,
            "Year": year
        }
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'POST',
            url: this.ROOT_URL + "/api/MaterialAllocation/MaterialAllocationDetails",
            headers: headers,
            body: _body
        })
        return this.http.request(new Request(requestoptions))
            .map((res: Response) => {
                return res.json();
            });

    }
    SavematerialAllocationDetails(Defination: string, AllocateID: number, RequirementID: number, JobNumber: string, UserID: string, UserRole: string, UserName: string, ApprovedQuantity: number, AllocatedQuantity: number, TotalRemaining: number, IsSavedasDraft: boolean, IsSubmitted: boolean, RequirementType: number, Regioncode: string): Observable<any> {
        let _body = {
            "defination": Defination,
            "AllocateID": AllocateID,
            "RequirementID": RequirementID,
            "JobNumber": JobNumber,
            "UserID": UserID,
            "UserRole": UserRole,
            "UserName": UserName,
            "ApprovedQuantity": ApprovedQuantity,
            "AllocatedQuantity": AllocatedQuantity,
            "TotalRemaining": TotalRemaining,
            "IsSavedasDraft": IsSavedasDraft,
            "IsSubmitted": IsSubmitted,
            "RequirementType": RequirementType,
            "Regioncode": Regioncode
        }
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'POST',
            url: this.ROOT_URL + "/api/MaterialAllocation/SaveMaterialAllocation",
            headers: headers,
            body: _body
        })
        return this.http.request(new Request(requestoptions))
            .map((res: Response) => {
                return res.json();
            });

    }

    DownloadmaterialAllocationExcel(month: string,year:string): Observable<any> {
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'POST',
            url: this.ROOT_URL + "/api/MaterialAllocation/DownloadMaterialAllocationExcel?Month=" + month + "&Year="+year,
            headers: headers,
            responseType: ResponseContentType.Blob,
        })
        return this.http.request(new Request(requestoptions))
            .map((res: Response) => {
                var blob = new Blob([res.blob()], { type: 'xlsx' })
                return blob;
            });
    }
    UploadmaterialAllocationExcel(fileList: any): Observable<any> {
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'POST',
            url: this.ROOT_URL + "/api/MaterialAllocation/UploadMaterialAllocationExcel",
            headers: headers,
            body: fileList,
            responseType: ResponseContentType.Json
        })
        return this.http.request(new Request(requestoptions))
            .map((res: Response) => {
                return res.json();
            });
    }
    GetMaterialAllocationRegion(jobNumber: string): Observable<any> {
        let userID = localStorage.getItem('mcmt_userId');
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'POST',
            url: this.ROOT_URL + "/api/MaterialAllocation/GetRegionMaterialAllocation?Jobnumber=" + jobNumber,
            headers: headers
        })
        return this.http.request(new Request(requestoptions))
            .map((res: Response) => {
                return res.json();
            });

    }

    //end region
    //   #region Production
    getProductionFilter(status: string): Observable<any> {
        let userID = localStorage.getItem('mcmt_userId');
        let _body = {
            "UserID": userID,
            "requirementDetailsId": status
        }
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'POST',
            url: this.ROOT_URL + "/api/Production/GetProductionFilters",
            headers: headers,
            body: _body
        })

        return this.http.request(new Request(requestoptions))
            .map((res: Response) => {
                return res.json();
            });

    }
    getProductionDetails(rmhName: any, jobType: any, brand: any, crop: any, language: any, month: any, status: any, jobNumber: any, state: any, vendor: any): Observable<any> {
        let _body = {
            "RMHName": rmhName,
            "JobType": jobType,
            "Brand": brand,
            "Crop": crop,
            "Language": language,
            "Month": month,
            "Status": status,
            "JobNumber": jobNumber,
            "State": state,
            "vendor": vendor
        }
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'POST',
            url: this.ROOT_URL + "/api/Production/GetProductionDetails",
            headers: headers,
            body: _body
        })

        return this.http.request(new Request(requestoptions))
            .map((res: Response) => {
                return res.json();
            });
    }
    GetProductionPrintingDetails(rmhName: any, jobType: any, brand: any, crop: any, language: any, month: any, status: any, jobNumber: any, state: any, vendor: any, year: string): Observable<any> {
        let _body = {
            "RMHName": rmhName,
            "JobType": jobType,
            "Brand": brand,
            "Crop": crop,
            "Language": language,
            "Month": month,
            "Status": status,
            "JobNumber": jobNumber,
            "State": state,
            "vendor": vendor,
            "Year": year
        }
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'POST',
            url: this.ROOT_URL + "/api/Production/GetProductionPrintingDetails",
            headers: headers,
            body: _body
        })

        return this.http.request(new Request(requestoptions))
            .map((res: Response) => {
                return res.json();
            });
    }

    GetProductionPrintingExcel(rmhName: any, jobType: any, brand: any, crop: any, language: any, month: any, status: any, jobNumber: any, state: any, vendor: any,year: string): Observable<any> {
        let _body = {
            "RMHName": rmhName,
            "JobType": jobType,
            "Brand": brand,
            "Crop": crop,
            "Language": language,
            "Month": month,
            "Status": status,
            "JobNumber": jobNumber,
            "State": state,
            "vendor": vendor,
            "Year": year
        }
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'POST',
            url: this.ROOT_URL + "/api/Production/DownloadProductionExcel",
            headers: headers,
            body: _body,
            responseType: ResponseContentType.Blob
        })
        return this.http.request(new Request(requestoptions))
            .map((res: Response) => {
                var blob = new Blob([res.blob()], { type: 'xlsx' })
                return blob;
            });

    }

    uploadProductionExcel(documents: File): Observable<any> {
        const formData = new FormData();
        formData.append("file", documents);
        formData.append("UserId", localStorage.getItem('mcmt_userId'));

        let headers = new Headers({ 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions: RequestOptions = new RequestOptions({
            headers: headers
        })
        return this.http.post(this.ROOT_URL + "/api/Production/UploadProductionExcel", formData, requestoptions)
            .map((res: Response) => {
                return res.json();
            });
    }

    GetRequirementDetailsZMH(rmhName: any, jobType: any, brand: any, crop: any, language: any, status: any, jobNumber: any,year:any): Observable<any> {
        let _body = {
            "UserID": localStorage.getItem('mcmt_userId'),
            "RMHName": rmhName,
            "JobType": jobType,
            "Brand": brand,
            "Crop": crop,
            "Language": language,
            "Status": status,
            "JobNumber": jobNumber,
            "Year": year

        }
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'POST',
            url: this.ROOT_URL + "/api/AnnualRequirement/GetAnnualRequirementDetailForZMHApproval",
            headers: headers,
            body: _body
        })

        return this.http.request(new Request(requestoptions))
            .map((res: Response) => {
                return res.json();
            });
    }
    GetAnnualRequirementDetailForZMHApprovalExcel(rmhName: any, jobType: any, brand: any, crop: any, language: any, status: any, jobNumber: any,year:any): Observable<any> {
        let _body = {
            "UserID": localStorage.getItem('mcmt_userId'),
            "RMHName": rmhName,
            "JobType": jobType,
            "Brand": brand,
            "Crop": crop,
            "Language": language,
            "Status": status,
            "JobNumber": jobNumber,
            "Year": year,
        }
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'POST',
            url: this.ROOT_URL + "/api/AnnualRequirement/GetAnnualRequirementDetailForZMHApprovalExcel",
            headers: headers,
            body:_body,
            responseType: ResponseContentType.Blob,
        })
        return this.http.request(new Request(requestoptions))
            .map((res: Response) => {
                var blob = new Blob([res.blob()], { type: 'xlsx' })
                return blob;
            });
    }
    GetRequirementDetailForJobCancellation(rmhName: any, jobType: any, brand: any, crop: any, language: any, status: any, jobNumber: any, requester: any, year: any): Observable<any> {
        let _body = {
            "UserID": localStorage.getItem('mcmt_userId'),
            "RMHName": rmhName,
            "JobType": jobType,
            "Brand": brand,
            "Crop": crop,
            "Language": language,
            "Status": status,
            "JobNumber": jobNumber,
            "Requested": requester,
            "Year": year
        }
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'POST',
            url: this.ROOT_URL + "/api/AnnualRequirement/GetRequirementDetailForJobCancellation",
            headers: headers,
            body: _body
        })

        return this.http.request(new Request(requestoptions))
            .map((res: Response) => {
                return res.json();
            });
    }
    getRequirementDetailsFiltersZMH(): Observable<any> {
        let userID = localStorage.getItem('mcmt_userId');
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'GET',
            url: this.ROOT_URL + "/api/AnnualRequirement/GetRequirementDetailsFiltersZMH?userID=" + userID,
            headers: headers
        })

        return this.http.request(new Request(requestoptions))
            .map((res: Response) => {
                return res.json();
            });

    }
    getRequirementDetailsForJobCancellation(): Observable<any> {
        let userID = localStorage.getItem('mcmt_userId');
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'GET',
            url: this.ROOT_URL + "/api/AnnualRequirement/GetRequirementDetailsForJobCancellation?userID=" + userID,
            headers: headers
        })

        return this.http.request(new Request(requestoptions))
            .map((res: Response) => {
                return res.json();
            });

    }
    UpdateProductionStatus(requirementDetailsId: any, status: any, AdditionalRequirequirementID: any): Observable<any> {
        let _body = {
            "UserID": localStorage.getItem('mcmt_userId'),
            "requirementDetailsId": requirementDetailsId,
            "status": status,
            "AdditionalRequirequirementID": AdditionalRequirequirementID
        }
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'POST',
            url: this.ROOT_URL + "/api/Production/UpdateProductionStatus",
            headers: headers,
            body: _body
        })
        return this.http.request(new Request(requestoptions))
            .map((res: Response) => {
                return res.json();
            });
    }
    updateArtworkStatus(Jobnumber:any,PONumber:any,ArtworkgiventoPrinter:any,PrinterSharedJpeg:any,ProofApproved:any,ProofApproverName:any): Observable<any> {
        let _body = {
            "LoggedInUser": localStorage.getItem('mcmt_userId'),
            "jobNumber": Jobnumber,
            "PONumber": PONumber,
            "ArtworkgiventoPrinter": ArtworkgiventoPrinter,
            "PrinterSharedJpeg":PrinterSharedJpeg,
            "ProofApproved":ProofApproved,
            "ProofApproverName":ProofApproverName
        }
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'POST',
            url: this.ROOT_URL + "/api/Production/updateArtworkStatus",
            headers: headers,
            body: _body
        })
        return this.http.request(new Request(requestoptions))
            .map((res: Response) => {
                return res.json();
            });
    }

    ApproveRequirement(Jobnumbers: any): Observable<any> {
        let _body = {
            "UserID": localStorage.getItem('mcmt_userId'),
            "JobNumber": Jobnumbers,

        }
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'POST',
            url: this.ROOT_URL + "/api/AnnualRequirement/ApproveRequirement",
            headers: headers,
            body: _body
        })
        return this.http.request(new Request(requestoptions))
            .map((res: Response) => {
                return res.json();
            });
    }
    CancelJobnumbers(Jobnumbers: any,Remarks:any,CancelledQty:any,ApprovedQty:any): Observable<any> {
        let _body = {
            "UserID": localStorage.getItem('mcmt_userId'),
            "JobNumber": Jobnumbers,
            "Remarks":Remarks,
            "CancelledQty":CancelledQty,
            "ApprovedQty":ApprovedQty

        }
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'POST',
            url: this.ROOT_URL + "/api/AnnualRequirement/CancelJobnumbers",
            headers: headers,
            body: _body
        })
        return this.http.request(new Request(requestoptions))
            .map((res: Response) => {
                return res.json();
            });
    }

    CancelAllJobnumbers(selectedJobnumber: MultiSelectCancellation[]): Observable<any> {
        let _body = {
            "UserID": localStorage.getItem('mcmt_userId'),
            "JobNumberUdt": selectedJobnumber
        }
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'POST',
            url: this.ROOT_URL + "/api/AnnualRequirement/CancelAllJobnumbers",
            headers: headers,
            body: _body
        })
        return this.http.request(new Request(requestoptions))
            .map((res: Response) => {
                return res.json();
            });
    }
    //   #endregion
    ////#region  Material Dispatch
    GetMaterialDispatchToField(rmhName: any, jobType: any, brand: any, crop: any, language: any, status: any, jobNumber: any, state: any, year: any): Observable<any> {
        let _body = {
            "RMHName": rmhName,
            "JobType": jobType,
            "Brand": brand,
            "Crop": crop,
            "Language": language,
            "Status": status,
            "JobNumber": jobNumber,
            "State": state,
            "Year": year
        }


        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'POST',
            url: this.ROOT_URL + "/api/MaterialDispatch/GetMaterialDispatchToField",
            headers: headers,
            body: _body
        })

        return this.http.request(new Request(requestoptions))
            .map((res: Response) => {
                return res.json();
            });
    }

    GetUserDetails(requirementID: any, jobNumber: string, requirementType: any): Observable<any> {
        let _body = {
            "requirementDetailsID": Number(requirementID),
            "jobNumber": jobNumber,
            "requirementType": Number(requirementType),
        }
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'POST',
            url: this.ROOT_URL + "/api/MaterialDispatch/GetUserDetailsForDispatch",
            headers: headers,
            body: _body
        })
        return this.http.request(new Request(requestoptions))
            .map((res: Response) => {
                return res.json();
            });
    }
    SaveDispatchDetails(userDetails: UserDetails): Observable<any> {
        let _body = {
            "RequirementDetailID": userDetails.requirementDetailID,
            "JobNumber": userDetails.jobNumber,
            "transportName": userDetails.transportName,
            "dispatchDate": userDetails.dispatchDate,
            "dispatchLocation": userDetails.dispatchLocation,
            "dispatchAddress": userDetails.dispatchAddress,
            "noOfBoxes": userDetails.noOfBoxes,
            "quantityDispatched": userDetails.quantityDispatched,
            "estimatedDelieveryDate": userDetails.estimatedDeliveryDate,
            "remarks": userDetails.remarks,
            "status": userDetails.statusID,
            "allocateID": userDetails.allocateID,
            "allocatedQuantity": userDetails.allocatedQuantity,
            "userName": userDetails.userName,
            "userID": userDetails.userID,
            "userRole": userDetails.userRole,
            "mobileNumber": userDetails.mobileNumber,
            "requirementType": userDetails.requirementType,
            "Regioncode": userDetails.regioncode
        }
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'POST',
            url: this.ROOT_URL + "/api/MaterialDispatch/SaveMaterialDispatchDetails",
            headers: headers,
            body: _body
        })
        return this.http.request(new Request(requestoptions))
            .map((res: Response) => {
                return res.json();
            });
    }

    DownloadMaterialDispatchExcel(status: string, year: string): Observable<any> {
        let _body = {
            "Status": status,
            "Year": year
        }
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'POST',
            url: this.ROOT_URL + "/api/MaterialDispatch/DownloadMaterialDispatchExcel",
            headers: headers,
            body: _body,
            responseType: ResponseContentType.Blob,
        })
        return this.http.request(new Request(requestoptions))
            .map((res: Response) => {
                var blob = new Blob([res.blob()], { type: 'xlsx' })
                return blob;
            });
    }

    UpdateMaterialDispatchStatus(requirementID: any, status: number, additionalRequirement: any): Observable<any> {
        let _body = {
            "requirementDetailID": requirementID,
            "additionalrequirementDetails": additionalRequirement,
            "status": status,
        }
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'POST',
            url: this.ROOT_URL + "/api/MaterialDispatch/UpdateMaterialDispatchStatus",
            headers: headers,
            body: _body
        })
        return this.http.request(new Request(requestoptions))
            .map((res: Response) => {
                return res.json();
            });
    }
    getMaterialDispatchFilter(): Observable<any> {
        let userID = localStorage.getItem('mcmt_userId');
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'GET',
            url: this.ROOT_URL + "/api/MaterialDispatch/MaterialDispatchFilter?userID=" + userID,
            headers: headers
        })

        return this.http.request(new Request(requestoptions))
            .map((res: Response) => {
                return res.json();
            });

    }


    GetProductionPrintingDetails_ByPoNumber(poNumber: any): Observable<any> {
        let _body = {
            "PoNumber": poNumber
           
        }
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'POST',
            url: this.ROOT_URL + "/api/Production/GetProductionPrintingDetailBy_PONumber",
            headers: headers,
            body: _body
        })

        return this.http.request(new Request(requestoptions))
            .map((res: Response) => {
                return res.json();
            });
    }


    //#endregion
}
